import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "thread-comment" }
const _hoisted_2 = { class: "thread-comment__body" }
const _hoisted_3 = { class: "thread-comment__name" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "thread-comment__icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont iprofile-icon" })
], -1)
const _hoisted_5 = { class: "thread-comment__username" }
const _hoisted_6 = { class: "thread-comment__time" }
const _hoisted_7 = { class: "thread-comment__text" }
const _hoisted_8 = { class: "thread-comment__actions" }
const _hoisted_9 = { class: "thread-comment__reply-action" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont ireply-icon" }, null, -1)
const _hoisted_11 = ["onClick"]

import { computed } from 'vue'

import { Comment } from '@/models/interfaces'
import { calendar } from '@/helpers/time'


export default /*#__PURE__*/_defineComponent({
  __name: 'Comment',
  props: {
    comment: null
  },
  emits: ['replyShow'],
  setup(__props: any, { emit }) {

const props = __props as {
  comment: Comment
};





const posted = computed(() => {
  return calendar(props.comment.created)
})

const parentComment = computed(() => {
  if (props.comment.parent) {
    return props.comment.parent
  }
  return props.comment
})

function showReply(): void {
  emit('replyShow', parentComment.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.comment.author.username), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(posted)), 1)
      ]),
      _createElementVNode("span", _hoisted_7, _toDisplayString(__props.comment.text), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("a", {
            class: "thread-comment__reply-text",
            onClick: _withModifiers(showReply, ["stop","prevent"])
          }, "Reply ", 8, _hoisted_11)
        ])
      ])
    ])
  ]))
}
}

})